import infoProcess from '../../assets/icons/info-process-icon.svg'
import { EEntityAction } from '@/constants/entity-action'

export const DetailsInfo = [
  {
    id: EEntityAction.ADD,
    heading: 'Create New Employee',
    text: '',
    icon: infoProcess,
  },
  {
    id: EEntityAction.EDIT,
    heading: 'Edit Employee',
    text: '',
    icon: infoProcess,
  },
]
